/**
 * The small "© <year> Grudge Match Games" line linking to the studio site. Shown at the end of the menu
 * screens (home, create, join, settings, privacy, how to play), the lobby, the welcome screen and the TV
 * lobby; never inside a game or over its controls. It sits in the page flow (after any sticky button), so
 * it can't cover anything; the screens it sits in already pad for the safe area.
 */
export const STUDIO_URL = 'https://grudgematchgames.com';

export function SiteFooter({ className = '', big = false }: { className?: string; big?: boolean }) {
  const year = new Date().getFullYear();
  return (
    <footer className={`flex justify-center text-center ${className}`} data-testid="site-footer">
      <a
        href={STUDIO_URL}
        target="_blank"
        rel="noopener noreferrer"
        className={`inline-block rounded-lg px-3 py-1.5 font-semibold text-mute/75 hover:text-paper focus-visible:text-paper focus-visible:outline-2 focus-visible:outline-paper transition-colors ${big ? 'text-xl' : 'text-xs'}`}
        data-testid="footer-link"
      >
        © {year} Grudge Match Games
      </a>
    </footer>
  );
}
